module.exports = __webpack_public_path__ + "media/bootstrap-icons/headset-cb55600a.svg";